import $ from 'jquery';
import 'gsap/TweenMax';

const timelines = [];
const items = document.querySelectorAll('[data-parallax]');

class Parallax {

  constructor(opt = {}) {

    this.sy = 0;

    window.addEventListener('scroll', (e) => {
      this.sy = window.pageYOffset || document.documentElement.scrollTop;
    })

    this.init();
  }

  init() {

    window.addEventListener('scroll', (e) => {
      this.sy = window.pageYOffset || document.documentElement.scrollTop;
    })

    $.each(items, (i, item) => {
        let timeline = new TimelineMax({ paused: true });

        timeline.to(item, 1, {
          y: item.getAttribute('data-parallax'),
          overwrite: "all",
          ease: Power0.easeNone
        });

        timelines.push(timeline);
    });

    TweenMax.ticker.addEventListener("tick", this.render, this, true, 1);

  }

  render () {
    $.each(items, (index, item) => {
        let from = item.getBoundingClientRect().top + this.sy - window.innerHeight;

        if (from < 0) {
          from = 0;
        }

        let norm = this.clamp(this.normalize(this.sy, from, item.getBoundingClientRect().top + this.sy + item.offsetHeight), 0, 1);
        timelines[index].progress(norm);
    });

  }

  clamp(value, min, max) {
    return value < min ? min : (value > max ? max : value);
  }

  normalize(value, min, max) {
    return (value - min) / (max - min);
  }
}

export default Parallax;



// WEBPACK FOOTER //
// ./themes/maisondubillard/_dev/js/components/parallax.js